import React from 'react';
import { CpuIcon, TrendingUpIcon, CrosshairIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full py-24 px-4 bg-brand-bg relative overflow-hidden" data-id="element-41">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-42" />

      <div className="max-w-5xl mx-auto text-center space-y-12 relative z-10" data-id="element-43">
        <div className="space-y-4" data-id="element-44">
          <h2 className="text-4xl md:text-5xl text-brand-gold" data-id="element-45">
            La Ingeniería Inversa de Cuotas
          </h2>
          <p className="text-xl text-brand-text max-w-3xl mx-auto leading-relaxed" data-id="element-46">
            Este no es un libro de predicciones mágicas. Es un sistema operativo
            que te enseña a leer el "precio" que la casa de apuestas le pone a
            un partido.
          </p>
        </div>

        <div className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 md:p-12 shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-47">
          <p className="text-lg md:text-xl text-brand-muted leading-relaxed mb-10" data-id="element-48">
            Aprenderás a identificar cuándo la casa se ha equivocado y dónde
            está el valor real, permitiéndote tomar decisiones basadas en datos
            técnicos, contexto humano y matemáticas de mercado, no en suerte.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-49">
            <div className="flex flex-col items-center text-center space-y-4" data-id="element-50">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-51">
                <CpuIcon className="w-8 h-8 text-brand-gold" data-id="element-52" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-53">Datos Técnicos</h3>
              <p className="text-brand-faint text-sm" data-id="element-54">
                Análisis estadístico avanzado y métricas subyacentes como xG.
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-55">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-56">
                <TrendingUpIcon className="w-8 h-8 text-brand-gold" data-id="element-57" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-58">
                Matemáticas de Mercado
              </h3>
              <p className="text-brand-faint text-sm" data-id="element-59">
                Cálculo de probabilidad implícita y detección de cuotas con
                valor.
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-60">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-61">
                <CrosshairIcon className="w-8 h-8 text-brand-gold" data-id="element-62" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-63">Contexto Humano</h3>
              <p className="text-brand-faint text-sm" data-id="element-64">
                Motivación, fatiga, lesiones y factores externos que las casas
                ignoran.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}